import { combineReducers } from 'redux';
import coreReducer from './core';
import appReducer from './app';
import authenticationReducer from '@sift/resift/redux/reducers/authentication.web';
import locationReducer from './location';
import loginReducer from './login';
// add the reducers in
// TODO: add the non asyncronous reducers here.
export const makeRootReducer = asyncReducers => {
  return combineReducers({
    app: appReducer,
    authentication: authenticationReducer,
    core: coreReducer,
    location: locationReducer,
    login: loginReducer,
    ...asyncReducers,
  });
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
